var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('basic-container',[_c('div',{staticStyle:{"width":"65%","height":"400px"},attrs:{"id":"main"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }